export default __webpack_public_path__ + "static/media/full-video-keyvisual.c1e78c92.svg";